import React from "react";
import { marketingCards } from "../data/content";

export default function MarketingAgent() {
  return (
    <section className="section-py">
      <div className="container text-center">
        <h2 className="section-title" style={{ fontSize: "1.7rem" }}>
          DON'T JUST CREATE A SHOWCASE PUT YOUR SHOWCASE TO WORK
        </h2>
        <p className="section-subtitle">
          Eligible Premium businesses may have access to SELECTEZI marketing
          capabilities, including promotional tools and Marketing Agent
          support, according to the applicable Premium package.
        </p>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-3 mt-4 text-start">
          {marketingCards.map((card, i) => {
            const Icon = card.icon;
            return (
              <div className="col" key={i}>
                <div className="marketing-card">
                  <div className="icon-wrap">
                    <Icon size={20} />
                  </div>
                  <p>{card.text}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="banner-flow mt-4">
          BUSINESS + MARKETING AGENT + SELECTEZI AI &rarr; DISCOVERY +
          CONNECTION + OPPORTUNITY
        </div>

        <p className="disclaimer-text">
          Marketing activity is intended to increase visibility and business
          connections. It does not guarantee sales, customers, profits,
          contracts, leads or any specific business result.
        </p>
      </div>
    </section>
  );
}
